var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconXml = function SvgIconXml(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-xml_svg__Capa_2",
    viewBox: "0 0 30.66 34.56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-xml_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.15.14H6.3a1.9 1.9 0 0 0-1.9 1.9v30.48c0 1.05.85 1.9 1.9 1.9h22.32a1.9 1.9 0 0 0 1.9-1.9v-23L21.13.13h.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.15.27v9.25h9.24",
    fill: "#ecf2f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2 0H6.3C5.17 0 4.26.92 4.26 2.04v30.48c0 1.13.92 2.04 2.04 2.04h22.32c1.13 0 2.04-.92 2.04-2.04V9.47zm.08.46 8.92 8.92h-8.92zm9.11 32.06c0 .98-.79 1.77-1.77 1.77H6.3c-.98 0-1.77-.79-1.77-1.77V2.04c0-.98.79-1.77 1.77-1.77h14.71v9.39h9.38v-.09z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.08,
    height: 13.04,
    y: 16.18,
    rx: 4.24,
    ry: 4.24,
    fill: "#f19b1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.79 25.96-1.33-2-1.17 2h-1.8l2.09-3.32-2.14-3.2h1.85l1.31 1.97 1.15-1.97h1.8l-2.07 3.29 2.16 3.23zM17.82 19.44v6.52h-1.59v-3.91l-1.46 3.91h-1.28l-1.47-3.92v3.92h-1.59v-6.52h1.88l1.83 4.51 1.81-4.51zM20.55 24.74h2.08v1.23h-3.67v-6.52h1.59z",
    fill: "#f1f1f1"
  }))));
};
export default SvgIconXml;